import { createAction, props } from '@ngrx/store';
import { TaxJurisdictionRate } from 'src/app/pages/orders/interfaces/tax-jurisdiction-rate.interface';
import { CheckTaxJurisdictionRate } from 'src/app/pages/orders/interfaces/check-tax-jurisdiction-rate.interface';

export const checkTaxJurisdictionRate = createAction(
  '[Tax Jurisdiction Rate] Check',
  props<{ params: CheckTaxJurisdictionRate }>(),
);

export const checkTaxJurisdictionRateSuccess = createAction(
  '[Tax Jurisdiction Rate] Check Success',
  props<{ response: TaxJurisdictionRate }>(),
);

export const checkTaxJurisdictionRateSuccessByKey = createAction(
  '[Tax Jurisdiction Rate] Check Success By Key',
  props<{ key: string; response: TaxJurisdictionRate }>(),
);

export const checkTaxJurisdictionRateFailure = createAction(
  '[Tax Jurisdiction Rate] Check Failure',
  props<{ error: any }>(),
);
